import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useHistory } from "react-router-dom";
import { candidateExplainerData as data } from "../data/candidate-explainer.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";
import "./candidate-explainer.scss";

export function SiSupportMore() {
  const redirect = useRedirectUrl("/second-interview-support");
  const history = useHistory();

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Candidate Explainer</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/second-interview-support/more-frequently-asked-questions/" />
      </Helmet>

      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          {data?.header_section?.breadcrums.map((b, i) => {
            switch (i) {
              case 0:
                return (
                  <li className={styles["candidateBtn"]} key={i}>
                    <a href={redirect}>{b.label}</a>
                  </li>
                );
              default:
                return b.link ? (
                  <li key={i}>
                    <Link to={b.link}>{b.label}</Link>
                  </li>
                ) : (
                  <span>{b.label}</span>
                );
            }
          })}
        </ul>

        <div className={styles["tableOfContent"]}>
          <h3>More frequently asked questions</h3>
          <ul>
            <li>
              <a href="#1">Where is my data going to be stored?</a>
            </li>
            <li>
              <a href="#2">What happens after I’ve completed my interview?</a>
            </li>
          </ul>
        </div>

        <div className={styles["siQA"]}>
          <div className={styles["siQAItem"]} id="1">
            <h4>Where is my data going to be stored?</h4>
            <p>
              We value your privacy and follow the highest standards to ensure
              that your data is stored in your country and only displayed to the
              appropriate people. For more information on our privacy policy
              please{" "}
              <a
                href=""
                onClick={() => {
                  history.push("/candidate-explainer-privacy-policy");
                }}
              >
                visit this page.
              </a>
            </p>
          </div>

          <div className={styles["siQAItem"]} id="2">
            <h4>What happens after I’ve completed my interview?</h4>
            <p>
              Once you have submitted your interview, the Talent Acquisition
              team at the company you have interviewed for will be in touch
              directly should they wish to proceed with your application.
            </p>
          </div>
        </div>
      </div>

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">{data.contact_section.section_title}</h3>
            <button
              type="button"
              className="btn-help"
              style={{ cursor: "pointer" }}
            >
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
            <p>
              <a href="/terms-of-service" className="black-link">
                Read our Terms of Service here {">"}
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
